import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getcontactAPi,deletecontactApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,   
};

// get contact
export const getcontact = createAsyncThunk('getcontact/contact', async () => {
    try {
        const response = await axios.get(`${getcontactAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'contacts' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete contact
export const deletecontacts = createAsyncThunk('deletecontacts/contact', async (contactid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletecontactApi}/${contactid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'contactid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const contactSlice = createSlice({
    name: 'contact',
    initialState: {
        contacts: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //getcontacts
            .addCase(getcontact.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getcontact.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.contacts = action.payload;
            })
            .addCase(getcontact.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete contacts
            .addCase(deletecontacts.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletecontacts.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.contacts.data = state.contacts.data.filter(contacts => contacts.contactid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletecontacts.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default contactSlice.reducer;
